var React = require('react');

function ErrorMsgIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5ZM6.99976 3.5H8.99976V10.5H6.99976L6.99976 3.5ZM8.99976 11.5H6.99976V13.5H8.99976V11.5Z","fill":"white"}));
}

ErrorMsgIcon.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = ErrorMsgIcon;

ErrorMsgIcon.default = ErrorMsgIcon;
